import React from "react";
import BaseToast from "../../sisu/messages/BaseToast.sisu";

const NeoToast = React.forwardRef((props, ref) => {
  return (<>
    <BaseToast {...props} ref={ref}/>
  </>);
})

export default NeoToast;